import { variables } from '../common/variables';
import {
  cl,
  capitalizeFirstLetter,
  getUnique,
  trimToLowerCase,
  makeScrollbar
} from '../common/functions';
import { map, markersCluster } from './leaflet/leaflet__map-init';
import { tagFilterButtonCustom } from './leaflet/leaflet-tag-filter-button--custom'

const createFilters = (arrayTypes, arrayCategories, group, types) => {
  /*------------ [FILTERS] ------------*/
  //creation d'une array clean pour creer les filtres
  const createFilterArray = () => {
    let mapArrayLowerCase = [];
    for (let i = 0; i < arrayCategories.length; i++) {
      const trimmedCategory = arrayCategories[i];
      cl(arrayCategories[i]);
      mapArrayLowerCase.push(`optGroup__separator--${trimmedCategory}`);
      const selectedCategoryTypes = types.filter(obj => Object.keys(obj).some(key => trimToLowerCase(obj[key]).includes(trimmedCategory)));
      !!selectedCategoryTypes.length && [...selectedCategoryTypes].forEach(selectedCategoryType => {
        const typeName = trimToLowerCase(selectedCategoryType.types_name);
        if (arrayTypes.includes(typeName)) {
          mapArrayLowerCase.push(typeName);
        }
      });
    }
    cl(mapArrayLowerCase);
    return mapArrayLowerCase;
  };
  /*------------ [LEAFLET] ------------*/
  // Filtres event
  const statusFilterButton = tagFilterButtonCustom({
    data: createFilterArray(),
    header: variables.shortcodeFiltersHeaderText,
    clearText: variables.shortcodeFiltersClearText,
    filterOnEveryClick: true,
    closeOnEveryClick: false,
    container: window.innerWidth >= variables.breakpoint ? "#stores__filters" : "#searchTab__filters",
    storeItemSelector: '.container__item',
    onSelectionComplete: (tags) => {
      map.fitBounds(group.getBounds().pad(0));
    }
  })
    .addTo(map);
  // Enable MCG integration
  statusFilterButton.enableMCG(markersCluster);
}

export { createFilters };
